import { render, staticRenderFns } from "./PaintworkformdetailsPage.vue?vue&type=template&id=aa6be278"
import script from "./PaintworkformdetailsPage.vue?vue&type=script&lang=js"
export * from "./PaintworkformdetailsPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports